import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const auth = localStorage.getItem("accessToken");

  return auth ? children : <Navigate to="/login" replace />;
}
